import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace(
  'city-of-inglewood-general-municipal-election-measure-bb-4348'
).catch(console.error);
